import React from 'react';
import { Navigate } from 'react-router-dom';
import { ConnectedComponent } from 'react-redux';
import { getIdTokenLocalStorage, isJwtValid } from './jwt';

type IProps = {
  loginURL: string;
  component: ConnectedComponent<React.ComponentType<any>, any>;
};

const ProtectedRoute: React.FC<IProps> = ({
  loginURL,
  component: Component,
}) => {
  const token = getIdTokenLocalStorage();
  const isValid = isJwtValid(token);

  if (!isValid) {
    return <Navigate to={loginURL} replace />;
  }

  return <Component />;
};

export default ProtectedRoute;
